import { connect, injectSaga } from '@vfde-sails/core';
import { mapStateToProps } from './selector';
import { AddressValidationId, AppContainerId, NameSpace } from '../../enum';
import { mountJustText, updateJustText } from '../../components/justText';
import { mountNotification, updateResultNotification } from '../../components/notification';
import { mountButtonLink } from '../../components/buttonLink';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { mountButton, updateResultButton } from '../../components/button';
import { getCMSConfig } from '../../util/cms';
import { changeAddress, deleteAddress } from '@vfde-sails/availability';
import { areObjectsDeeplyEqual } from '@vfde-sails/utils';
import { setOverlayVisibility, setSelectedProduct } from '../App/action';
import justTextUtil from '../../util/component/justText.utils';
import addressValidationSaga from './saga';
import { mountHeadline, updateHeadline } from '../../components/headline';

const actionMap = {
    changeAddress,
    deleteAddress,
    setSelectedProduct,
    setOverlayVisibility,
};

export type AddressValidationProps = ReturnType<typeof mapStateToProps>;
export type AddressValidationActions = typeof actionMap;

function addressValidationContainer (props: AddressValidationProps, actions: AddressValidationActions) {
    injectSaga(NameSpace.ADDRESS_VALIDATION, addressValidationSaga);

    const cmsProps = getCMSConfig();

    const moreInfoHeadline = mountHeadline(AddressValidationId.MORE_INFO_HEADLINE);
    const moreInfoSubline = mountJustText(AddressValidationId.MORE_INFO_SUBLINE);
    const addressText = mountJustText(AddressValidationId.ADDRESS);
    const resultAddressText = mountJustText(AddressValidationId.RESULT_ADDRESS);
    const notification = mountNotification(AddressValidationId.NOTIFICATION);
    const button = mountButton(AddressValidationId.BUTTON);

    mountButtonLink(AddressValidationId.DELETE_BUTTON, actions.deleteAddress);
    mountButtonLink(AddressValidationId.CHANGE_BUTTON, actions.changeAddress);

    toggleElementVisibilityById(AddressValidationId.RESULT_WRAPPER, Boolean(props.address));
    toggleElementVisibilityById(AppContainerId.ADDRESS_BLOCK, Boolean(props.address));

    return {
        getDerivedStateFromProps(newProps: AddressValidationProps, oldProps: AddressValidationProps) {
            const { address, availability, result, selectedId, customer, tvConnectBv } = newProps;

            const isAddressChecked = Boolean(result);
            const shouldUpdate = !areObjectsDeeplyEqual(result, oldProps.result);

            if (!shouldUpdate) {
                return;
            }

            updateHeadline(moreInfoHeadline, justTextUtil.getMoreInfoHeadline(cmsProps.moreInfo, customer?.hasKipContract, tvConnectBv));
            updateJustText(moreInfoSubline, justTextUtil.getMoreInfoSubline(newProps, cmsProps.moreInfo));
            updateJustText(addressText, address);
            updateJustText(resultAddressText, address);
            updateResultNotification(notification, cmsProps.availability.notification, availability);
            updateResultButton(button, cmsProps.availability.button, actions, availability, selectedId);

            toggleElementVisibilityById(AppContainerId.ADDRESS_BLOCK, isAddressChecked && !customer);
            toggleElementVisibilityById(AddressValidationId.ALTERNATIVE, !availability.cableTv);
        },
    };
}

export default connect(mapStateToProps, actionMap)(addressValidationContainer);
